
function Footer() {
    return (
    <div>
        <footer className="text-center text-white bg-dark-theme" style={{backgroundcolor: "#21081a"}}>
  <div className="container-fluid"></div>
  <div className="text-center p-3" style={{backgroundcolor: "rgba(0, 0, 0, 0.2);"}}>
    © 2022 Copyright: Bhumit Patel </div>
</footer>
    </div>
    );
}

export default Footer;